import { forwardRef } from "react";

import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

const CustomizedComponent = styled(IconButton)(
  ({ theme }) => `
    color: ${theme.palette.primary.contrastText},  
  `,
);

const AppBarIconButton = (props, ref) => {
  return <CustomizedComponent ref={ref} {...props} />;
};

export default forwardRef(AppBarIconButton);
